import React from 'react';
import Typography from '@material-ui/core/Typography';

import useStyles from './Copyright.style';

const Copyright: React.FC = () => {
  const { copyright } = useStyles();
  return (
    <Typography variant="caption" align="center" className={copyright}>
      Copyright
      {` ${new Date().getFullYear()} `}
      BitTitan, Inc. All Rights Reserved.
    </Typography>
  );
};

export default Copyright;
